import React from 'react';
import OddsButton from '../../../../../OddsButton/OddsButton';

const Deactive = ({ outcomesCount }) => {
    let outcomes = [];

    for (let i = 0; i < outcomesCount; i++) {
        outcomes.push(`${i}-${new Date().getTime()}`);
    }

    return outcomes.map(key => (
        <td key={key}>
            <OddsButton isNull />
        </td>
    ));
};

export default Deactive;
